import getBasketItems from './getBasketItems';
import sendToBasket from './sendToBasket';

import getComparesList from './getComparesList';
import addToComparesList from './addToComparesList';
import removeFromCompares from './removeFromCompares';

import getFavoritesList from './getFavoritesList';
import addToFavoritesList from './addToFavoritesList';
import removeFromFavorites from './removeFromFavorites';

window.digiLayer = {};

window.digiLayer.cartState = getBasketItems;
window.digiLayer.addToCart = sendToBasket;

window.digiLayer.whishlistState = getFavoritesList;
window.digiLayer.addToWishlist = addToFavoritesList;
window.digiLayer.removeFromWishlist = removeFromFavorites;

window.digiLayer.comparesState = getComparesList;
window.digiLayer.addToCompare = addToComparesList;
window.digiLayer.removeFromCompare = removeFromCompares;
